module.exports = __webpack_public_path__ + "static/img/ft1.ffb50318.png";